
<div class="documentBox">

<!-- Filter -->
<mat-card class="filter">
  <div class="sortview">
      <div class="sortby">
          <mat-form-field>
              <mat-label>Filter by</mat-label>
              <mat-select >
                <mat-option value="" >All</mat-option>
                <mat-option value="">Date</mat-option>
              </mat-select>
            </mat-form-field>
      </div>
  </div>
</mat-card>
<!-- Filter -->
<div class="documents">
  <mat-accordion>
  

      <mat-expansion-panel [expanded]="true" >
  
        <mat-expansion-panel-header>
          <mat-panel-title class="header" >
            <div class="titleCount">
                  <div class="folderName">Requested Documents<span class="count">2</span></div>
            </div>
           
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="documentcontainer">
          <mat-card class="table">
              <table class="mat-table">
                <thead>
                <tr class="mat-header-row">
                  <th class="mat-header-cell w-60"></th>
                  <th class="mat-header-cell">Document Name</th>
                  <th class="mat-header-cell">URL</th>
                  <th class="mat-header-cell">Created On</th>
                  <th class="mat-header-cell">Requested by </th>
                  <th class="mat-header-cell text-center w-100">Delete</th>
                </tr>
          
              </thead>
                <tbody> 
                <tr class="mat-row">
                  <td class="mat-cell text-grey">
                   1
                  </td>
                  <td class="mat-cell">
                    Rent Agreement
                  </td>
                  <td class="mat-cell">
                      <!-- <a href="">https://mattmcalpin.visualstudio.com</a> -->
                      <button mat-icon-button  (click)="customizeColumn(customize)" ><mat-icon>file_copy</mat-icon></button>
                  </td>
                  <td class="mat-cell">
                   26/06/20
                  </td>
                  <td class="mat-cell">
                    Matt
                  </td>
                  <td class="mat-cell text-center">
                    <button mat-icon-button class="text-grey">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
              </table>
            </mat-card>
        </div>
      </mat-expansion-panel>
  
    </mat-accordion>
</div>

</div>




<ng-template #customize>
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center" >
        <h2 matDialogTitle>Enter Document Password</h2> 
        <mat-icon (click)="close()" >close</mat-icon>
    </div>
    

    <mat-dialog-content>
  
      <form >
        <mat-form-field >
          <mat-label>Enter Password</mat-label>
          <input matInput type="password" placeholder="Enter password" formControlName="">
        </mat-form-field>
      
     
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center" >
      <button mat-button  color="basic" (click)="close()">Cancel</button>
      <button mat-button  color="primary" >Submit</button>
    </mat-dialog-actions>
  </ng-template>


